// removed by extract-text-webpack-plugin
module.exports = {"app":"_3sz-Jorbvi2LDO38TpQcMl","bodyLayer":"IE-Jsao6mk4nLUrDwNOm1","brand":"_u4avc-WstuZP5sdbqIV1","brandLink":"_3t6dNIlRc_MnISgIlhAq_m","title":"_6snqj3tTWVaXXufD7tzFs","user":"vwOMZYhBucEiKp8SR4awY","loggedInMessage":"NUM-ptrPXIUN8yCGIfccC","logout":"_3V1teblU3HJ20Yab-WLSm6","userIcon":"_3jYcGiNaEd0soU-kWlHFxh","navbar":"_3HuSzGVQWr3jI8H6ENhu1P","navMenu":"_3X4MReJ4FeoApOpd5alwAp","loader":"_2omEXVa1JaIW3MPvGCUgJX","notify":"_1_I-hCOEBjF6n8sQLxizTV","success":"_1T4auuTKrFvZuqn5Kp8usq","error":"_3-XkqJgSDTTyQzrSnFV0X3"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/App/App.scss
// module id = 660
// module chunks = 0